module.exports = __webpack_public_path__ + "img/zuihou.33f70652.webp";